module.exports = __webpack_public_path__ + "img/logo-gia.4668cdc.png";